import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { TrainingHero as Desk } from './desk'
import { TrainingHero as Mob } from './mob'

type Props = {
  images: TImages
}
export const TrainingHero: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component images={images} />
}
